module.exports = __webpack_public_path__ + "static/media/IMS-Logo.e9b48941.gif";